/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrgExtScanSessionResultModel } from '../../models/org-ext-scan-session-result-model';

export interface OrgExtSessionHistoryOrganizationIdPersonIdGet$Params {
  organizationId: string;
  personId: string;
  fromDate?: string;
  toDate?: string;
}

export function orgExtSessionHistoryOrganizationIdPersonIdGet(http: HttpClient, rootUrl: string, params: OrgExtSessionHistoryOrganizationIdPersonIdGet$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<Array<OrgExtScanSessionResultModel>>> {
  const rb = new RequestBuilder(rootUrl, orgExtSessionHistoryOrganizationIdPersonIdGet.PATH, 'get');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.path('personId', params.personId, {});
    rb.query('fromDate', params.fromDate, {});
    rb.query('toDate', params.toDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<Array<OrgExtScanSessionResultModel>>;
    })
  );
}

orgExtSessionHistoryOrganizationIdPersonIdGet.PATH = '/OrgExt/SessionHistory/{organizationId}/{personId}';
